export const COOKIES_ENABLED = "cookiesEnabled";
export const SCREEN_LOADING = "screenLoading";
export const SET_APP_PROPERTY = "setAppProperty";
export const SET_QUESTION_ANSWER = "setQuestionAnswer";
export const CLEAR_ALL = "clearAll";
export const CHANGE_OBJECT_PROPERTY = "changeObjectProperty";
export const ADD_NEW_ADULT = "addNewAdult";
export const REMOVE_OTHER_ADULT = "removeAdult";
export const UPDATE_OTHER_ADULT = "updateAdult";
export const SET_OTHER_ADULT_FILES = "setOtherAdultFiles";
export const REMOVE_FILES = "removeFiles";
